// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as FeedbackAction } from '../duck';
import Feedback from '../components/Feedback';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    isPostingFeedback: state.order.purchase.feedback.isPostingFeedback,
    postFeedbackSuccessful: state.order.purchase.feedback.postFeedbackSuccessful,
    postFeedbackError: state.order.purchase.feedback.postFeedbackError,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(FeedbackAction, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/feedback/containers/FeedbackContainer.js